<template>
    <el-row>
      <el-col :span="3">&nbsp;</el-col>
      <el-col :span="18">
         <div class="smain">
           <el-row>
            <el-col :span="11"> <div class="leftone"></div> </el-col>
            <el-col :span="2">&nbsp;</el-col>
            <el-col :span="11"> <div class="rightone"></div></el-col>
          </el-row>


          <el-row>
            <el-col :span="11"> <div class="lefttwo" id="lefttwo" @mouseover="leftover" @mouseout="rightout"></div> </el-col>
            <el-col :span="2">&nbsp;</el-col>
            <el-col :span="11"> <div class="righttwo" id="righttwo" @onmouseover="" @onmouseout=""></div></el-col>
          </el-row>
        </div>
      </el-col>
      <el-col :span="3">&nbsp;</el-col>
    </el-row>
</template>
<script>
export default{
  methods:{
    leftover(){
        document.getElementById('lefttwo').style.top="0";
        document.getElementById('lefttwo').style.height="400px";
        document.getElementById('lefttwo').style.border="2px solid #000000";
    },
    rightout(){
        document.getElementById('lefttwo').style.top="180px";
        document.getElementById('lefttwo').style.height="130px";
        document.getElementById('lefttwo').style.border="1px solid red";
    }
  }
}
</script>

<style scoped="scoped">
  .smain{
    position:relative;
    border:1px solid blue;
    clear:both;

  }
  .leftone{
    position:absolute;
    top:30px;
    left:0px;
    height:130px;
    border:1px solid red;
    width:40%;
  }
  .rightone{
    position:absolute;
    top:30px;
    right:0px;
    height:130px;
    border:1px solid yellow;
    width:40%;
  }
  .lefttwo{
    position:absolute;
    top:180px;
    left:0px;
    height:130px;
    border:1px solid red;
    width:40%;
  }
  .righttwo{
    position:absolute;
    top:180px;
    right:0px;
    height:130px;
    border:1px solid yellow;
    width:40%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Smart.vue